const initialState = {
    sites: [],
    createdSite: null,
    createSiteStatus: null,
    siteDetails: null,
    elementDetails: null,
    createElementStatus: null,
    uploadProtocolStatus: null,
    uploadProtocolResponse: null,
    protocols: [],
    deleteProtocolStatus: null,
    createElementWithAIStatus: null,
    createExistingElementWithAIStatus: null,
    inspectionTemplate: null,
};

export function maintainenceInspectionReducer(state = initialState, action) {
    switch (action.type) {
        case "GET_ALL_SITES_SUCCESS":
            return {
                ...state,
                sites: action.payload,
            };
        case "CREATE_SITE_SUCCESS":
            return {
                ...state,
                createdSite: action.payload,
                createSiteStatus: "success",
            };
        case "GET_SITE_DETAILS_SUCCESS":
            return {
                ...state,
                siteDetails: action.payload,
            };
        case "CREATE_ELEMENT_SUCCESS":
            return {
                ...state,
                elementDetails: action.payload,
            };
        case "GET_ELEMENT_DETAILS_SUCCESS":
            return {
                ...state,
                elementDetails: action.payload,
            };
        case "UPLOAD_PROTOCOL_SUCCESS":
            return {
                ...state,
                uploadProtocolResponse: action.payload,
                uploadProtocolStatus: "success",
            };
        case "GET_PROTOCOLS_SUCCESS":
            return {
                ...state,
                protocols: action.payload,
            };
        case "DELETE_PROTOCOL_SUCCESS":
            return {
                ...state,
                deleteProtocolStatus: "success",
            };
        case "CREATE_ELEMENT_WITH_AI_SUCCESS":
            return {
                ...state,
                createElementWithAIStatus: "success",
            };
        case "CREATE_EXISTING_ELEMENT_WITH_AI_SUCCESS":
            return {
                ...state,
                createExistingElementWithAIStatus: "success",
            };
        case "GET_INSPECTION_TEMPLATE_SUCCESS":
            return {
                ...state,
                inspectionTemplate: action.payload,
            };
        // ...other cases...
        default:
            return state;
    }
}

export const getAllSitesSuccess = (data) => ({
    type: "GET_ALL_SITES_SUCCESS",
    payload: data,
});

export const createSiteSuccess = (data) => ({
    type: "CREATE_SITE_SUCCESS",
    payload: data,
});

export const getSiteDetailsSuccess = (data) => ({
    type: "GET_SITE_DETAILS_SUCCESS",
    payload: data,
});

export const createElementSuccess = (data) => ({
    type: "CREATE_ELEMENT_SUCCESS",
    payload: data,
});

export const getElementDetailsSuccess = (data) => ({
    type: "GET_ELEMENT_DETAILS_SUCCESS",
    payload: data,
});

export const uploadProtocolSuccess = (data) => ({
    type: "UPLOAD_PROTOCOL_SUCCESS",
    payload: data,
});

export const getProtocolsSuccess = (data) => ({
    type: "GET_PROTOCOLS_SUCCESS",
    payload: data,
});

export const getDeleteProtocolSuccess = (data) => ({
    type: "DELETE_PROTOCOL_SUCCESS",
    payload: data,
});

export const getCreateElementWithAISuccess = (data) => ({
    type: "CREATE_ELEMENT_WITH_AI_SUCCESS",
    payload: data,
});

export const getCreateExistingElementWithAISuccess = (data) => ({
    type: "CREATE_EXISTING_ELEMENT_WITH_AI_SUCCESS",
    payload: data,
});

export const getInspectionTemplateSuccess = (data) => ({
    type: "GET_INSPECTION_TEMPLATE_SUCCESS",
    payload: data,
});